import { Transition } from '@headlessui/react'
import { type TFunction } from 'i18next'

interface FormContentProps {
	isBusy: string
	isTransitioning: boolean
	currentStep: number
	currentQuestionId?: string
	component: (props: any) => JSX.Element
	register: Function
	getValues: Function
	dispatch: Function
	control: any
	handleSubmit: Function
	onSubmit: Function
	onInvalid: Function
	watch: Function
	t: TFunction
}

export const FormContent = ({
	isBusy,
	isTransitioning,
	currentStep,
	currentQuestionId,
	component,
	register,
	getValues,
	dispatch,
	control,
	handleSubmit,
	onSubmit,
	onInvalid,
	watch,
	t,
}: FormContentProps) => {
	const contentProps = {
		register,
		getValues,
		dispatch,
		control,
		watch,
		handleSubmit: () => handleSubmit(onSubmit, onInvalid),
		t,
	}

	return (
		isBusy === 'idle' && (
			<div className="mx-2 h-full">
				<Transition
					show={!isTransitioning || isBusy !== 'idle'}
					enter="transition-opacity duration-200"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="transition-opacity duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
					className="h-full"
				>
					<div
						key={`${currentStep}-${currentQuestionId}`}
						className={`${isTransitioning ? 'opacity-0' : ''} h-full `}
					>
						{component && component(contentProps)}
					</div>
				</Transition>
			</div>
		)
	)
}
